export const routerPaths = {
  '/api/voice-preview/:language/:voiceId'(params: { language: string | number, voiceId: string | number }) {
    return buildPath('/api/voice-preview/:language/:voiceId', params)
  },
  '/api/audio/stream/:streamId'(params: { streamId: string | number }) {
    return buildPath('/api/audio/stream/:streamId', params)
  },
  '/auth/:provider/callback'(params: { provider: string | number }) {
    return buildPath('/auth/:provider/callback', params)
  },
  '/auth/magic-link/verify': '/auth/magic-link/verify',
  '/auth/magic-link/code': '/auth/magic-link/code',
  '/auth/google/one-tap': '/auth/google/one-tap',
  '/api/session/listen': '/api/session/listen',
  '/api/session/clear': '/api/session/clear',
  '/api/session/close': '/api/session/close',
  '/api/session/turns': '/api/session/turns',
  '/api/session/voice': '/api/session/voice',
  '/checkout/:priceId'(params: { priceId: string | number }) {
    return buildPath('/checkout/:priceId', params)
  },
  '/api/session/turn': '/api/session/turn',
  '/api/session/turn/:turnId/events'(params: { turnId: string | number }) {
    return buildPath('/api/session/turn/:turnId/events', params)
  },
  '/api/audio/trace': '/api/audio/trace',
  '/auth/magic-link': '/auth/magic-link',
  '/auth/:provider'(params: { provider: string | number }) {
    return buildPath('/auth/:provider', params)
  },
  '/indexnow.txt': '/indexnow.txt',
  '/sitemap.xml': '/sitemap.xml',
  '/stripe-portal': '/stripe-portal',
  '/robots.txt': '/robots.txt',
  '/auth/logout': '/auth/logout',
  '/auth/login': '/auth/login',
  '/feed.xml': '/feed.xml',
  '/': '/',
  '/relajacion-progresiva-de-jacobson': '/relajacion-progresiva-de-jacobson',
  '/progressive-muscle-relaxation': '/progressive-muscle-relaxation',
  '/what-is-ericksonian-hypnosis': '/what-is-ericksonian-hypnosis',
  '/ai-hypnosis-how-it-works': '/ai-hypnosis-how-it-works',
  '/hypnosis-for-confidence': '/hypnosis-for-confidence',
  '/hypnosis-vs-meditation': '/hypnosis-vs-meditation',
  '/meditation-for-anxiety': '/meditation-for-anxiety',
  '/hypnosis-for-anxiety': '/hypnosis-for-anxiety',
  '/hypnosis-for-stress': '/hypnosis-for-stress',
  '/autogenes-training': '/autogenes-training',
  '/hypnosis-for-focus': '/hypnosis-for-focus',
  '/hypnosis-for-sleep': '/hypnosis-for-sleep',
  '/jiritsu-kunren-ho': '/jiritsu-kunren-ho',
  '/meditacion-guiada': '/meditacion-guiada',
  '/training-autogeno': '/training-autogeno',
  '/trening-autogenny': '/trening-autogenny',
  '/sleep-meditation': '/sleep-meditation',
  '/:lang?'(params: { lang: string | number | undefined }) {
    return buildPath('/:lang?', params)
  },
  '/zi-wo-cui-mian': '/zi-wo-cui-mian',
  '/sophrologie': '/sophrologie',
  '/meditation': '/meditation',
  '/yoga-nidra': '/yoga-nidra',
  '/session': '/session',
  '/legal': '/legal',
  '/nsdr': '/nsdr',
  '/webhook': '/webhook',
  '/health': '/health'
} as const

export const unsafeRouterPaths = {
  '/api/voice-preview/:language/:voiceId'(params: Record<string, unknown>) {
    return unsafeBuildPath('/api/voice-preview/:language/:voiceId', params)
  },
  '/api/audio/stream/:streamId'(params: Record<string, unknown>) {
    return unsafeBuildPath('/api/audio/stream/:streamId', params)
  },
  '/auth/:provider/callback'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/:provider/callback', params)
  },
  '/auth/magic-link/verify'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/magic-link/verify', params)
  },
  '/auth/magic-link/code'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/magic-link/code', params)
  },
  '/auth/google/one-tap'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/google/one-tap', params)
  },
  '/api/session/listen'(params: Record<string, unknown>) {
    return unsafeBuildPath('/api/session/listen', params)
  },
  '/api/session/clear'(params: Record<string, unknown>) {
    return unsafeBuildPath('/api/session/clear', params)
  },
  '/api/session/close'(params: Record<string, unknown>) {
    return unsafeBuildPath('/api/session/close', params)
  },
  '/api/session/turns'(params: Record<string, unknown>) {
    return unsafeBuildPath('/api/session/turns', params)
  },
  '/api/session/voice'(params: Record<string, unknown>) {
    return unsafeBuildPath('/api/session/voice', params)
  },
  '/checkout/:priceId'(params: Record<string, unknown>) {
    return unsafeBuildPath('/checkout/:priceId', params)
  },
  '/api/session/turn'(params: Record<string, unknown>) {
    return unsafeBuildPath('/api/session/turn', params)
  },
  '/api/session/turn/:turnId/events'(params: Record<string, unknown>) {
    return unsafeBuildPath('/api/session/turn/:turnId/events', params)
  },
  '/api/audio/trace'(params: Record<string, unknown>) {
    return unsafeBuildPath('/api/audio/trace', params)
  },
  '/auth/magic-link'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/magic-link', params)
  },
  '/auth/:provider'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/:provider', params)
  },
  '/indexnow.txt'(params: Record<string, unknown>) {
    return unsafeBuildPath('/indexnow.txt', params)
  },
  '/sitemap.xml'(params: Record<string, unknown>) {
    return unsafeBuildPath('/sitemap.xml', params)
  },
  '/stripe-portal'(params: Record<string, unknown>) {
    return unsafeBuildPath('/stripe-portal', params)
  },
  '/robots.txt'(params: Record<string, unknown>) {
    return unsafeBuildPath('/robots.txt', params)
  },
  '/auth/logout'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/logout', params)
  },
  '/auth/login'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/login', params)
  },
  '/feed.xml'(params: Record<string, unknown>) {
    return unsafeBuildPath('/feed.xml', params)
  },
  '/'(params: Record<string, unknown>) {
    return unsafeBuildPath('/', params)
  },
  '/relajacion-progresiva-de-jacobson'(params: Record<string, unknown>) {
    return unsafeBuildPath('/relajacion-progresiva-de-jacobson', params)
  },
  '/progressive-muscle-relaxation'(params: Record<string, unknown>) {
    return unsafeBuildPath('/progressive-muscle-relaxation', params)
  },
  '/what-is-ericksonian-hypnosis'(params: Record<string, unknown>) {
    return unsafeBuildPath('/what-is-ericksonian-hypnosis', params)
  },
  '/ai-hypnosis-how-it-works'(params: Record<string, unknown>) {
    return unsafeBuildPath('/ai-hypnosis-how-it-works', params)
  },
  '/hypnosis-for-confidence'(params: Record<string, unknown>) {
    return unsafeBuildPath('/hypnosis-for-confidence', params)
  },
  '/hypnosis-vs-meditation'(params: Record<string, unknown>) {
    return unsafeBuildPath('/hypnosis-vs-meditation', params)
  },
  '/meditation-for-anxiety'(params: Record<string, unknown>) {
    return unsafeBuildPath('/meditation-for-anxiety', params)
  },
  '/hypnosis-for-anxiety'(params: Record<string, unknown>) {
    return unsafeBuildPath('/hypnosis-for-anxiety', params)
  },
  '/hypnosis-for-stress'(params: Record<string, unknown>) {
    return unsafeBuildPath('/hypnosis-for-stress', params)
  },
  '/autogenes-training'(params: Record<string, unknown>) {
    return unsafeBuildPath('/autogenes-training', params)
  },
  '/hypnosis-for-focus'(params: Record<string, unknown>) {
    return unsafeBuildPath('/hypnosis-for-focus', params)
  },
  '/hypnosis-for-sleep'(params: Record<string, unknown>) {
    return unsafeBuildPath('/hypnosis-for-sleep', params)
  },
  '/jiritsu-kunren-ho'(params: Record<string, unknown>) {
    return unsafeBuildPath('/jiritsu-kunren-ho', params)
  },
  '/meditacion-guiada'(params: Record<string, unknown>) {
    return unsafeBuildPath('/meditacion-guiada', params)
  },
  '/training-autogeno'(params: Record<string, unknown>) {
    return unsafeBuildPath('/training-autogeno', params)
  },
  '/trening-autogenny'(params: Record<string, unknown>) {
    return unsafeBuildPath('/trening-autogenny', params)
  },
  '/sleep-meditation'(params: Record<string, unknown>) {
    return unsafeBuildPath('/sleep-meditation', params)
  },
  '/:lang?'(params: Record<string, unknown>) {
    return unsafeBuildPath('/:lang?', params)
  },
  '/zi-wo-cui-mian'(params: Record<string, unknown>) {
    return unsafeBuildPath('/zi-wo-cui-mian', params)
  },
  '/sophrologie'(params: Record<string, unknown>) {
    return unsafeBuildPath('/sophrologie', params)
  },
  '/meditation'(params: Record<string, unknown>) {
    return unsafeBuildPath('/meditation', params)
  },
  '/yoga-nidra'(params: Record<string, unknown>) {
    return unsafeBuildPath('/yoga-nidra', params)
  },
  '/session'(params: Record<string, unknown>) {
    return unsafeBuildPath('/session', params)
  },
  '/legal'(params: Record<string, unknown>) {
    return unsafeBuildPath('/legal', params)
  },
  '/nsdr'(params: Record<string, unknown>) {
    return unsafeBuildPath('/nsdr', params)
  },
  '/webhook'(params: Record<string, unknown>) {
    return unsafeBuildPath('/webhook', params)
  },
  '/health'(params: Record<string, unknown>) {
    return unsafeBuildPath('/health', params)
  }
} as const

export type RouterPath = keyof typeof routerPaths

export type RouterParams = {
  '/api/voice-preview/:language/:voiceId': { language: string, voiceId: string },
  '/api/audio/stream/:streamId': { streamId: string },
  '/auth/:provider/callback': { provider: string },
  '/auth/magic-link/verify': {  },
  '/auth/magic-link/code': {  },
  '/auth/google/one-tap': {  },
  '/api/session/listen': {  },
  '/api/session/clear': {  },
  '/api/session/close': {  },
  '/api/session/turns': {  },
  '/api/session/voice': {  },
  '/checkout/:priceId': { priceId: string },
  '/api/session/turn': {  },
  '/api/session/turn/:turnId/events': { turnId: string },
  '/api/audio/trace': {  },
  '/auth/magic-link': {  },
  '/auth/:provider': { provider: string },
  '/indexnow.txt': {  },
  '/sitemap.xml': {  },
  '/stripe-portal': {  },
  '/robots.txt': {  },
  '/auth/logout': {  },
  '/auth/login': {  },
  '/feed.xml': {  },
  '/': {  },
  '/relajacion-progresiva-de-jacobson': {  },
  '/progressive-muscle-relaxation': {  },
  '/what-is-ericksonian-hypnosis': {  },
  '/ai-hypnosis-how-it-works': {  },
  '/hypnosis-for-confidence': {  },
  '/hypnosis-vs-meditation': {  },
  '/meditation-for-anxiety': {  },
  '/hypnosis-for-anxiety': {  },
  '/hypnosis-for-stress': {  },
  '/autogenes-training': {  },
  '/hypnosis-for-focus': {  },
  '/hypnosis-for-sleep': {  },
  '/jiritsu-kunren-ho': {  },
  '/meditacion-guiada': {  },
  '/training-autogeno': {  },
  '/trening-autogenny': {  },
  '/sleep-meditation': {  },
  '/:lang?': { lang: string | undefined },
  '/zi-wo-cui-mian': {  },
  '/sophrologie': {  },
  '/meditation': {  },
  '/yoga-nidra': {  },
  '/session': {  },
  '/legal': {  },
  '/nsdr': {  },
  '/webhook': {  },
  '/health': {  }
}

type InputParams = {
  '/api/voice-preview/:language/:voiceId': { language: string | number, voiceId: string | number },
  '/api/audio/stream/:streamId': { streamId: string | number },
  '/auth/:provider/callback': { provider: string | number },
  '/auth/magic-link/verify': {  },
  '/auth/magic-link/code': {  },
  '/auth/google/one-tap': {  },
  '/api/session/listen': {  },
  '/api/session/clear': {  },
  '/api/session/close': {  },
  '/api/session/turns': {  },
  '/api/session/voice': {  },
  '/checkout/:priceId': { priceId: string | number },
  '/api/session/turn': {  },
  '/api/session/turn/:turnId/events': { turnId: string | number },
  '/api/audio/trace': {  },
  '/auth/magic-link': {  },
  '/auth/:provider': { provider: string | number },
  '/indexnow.txt': {  },
  '/sitemap.xml': {  },
  '/stripe-portal': {  },
  '/robots.txt': {  },
  '/auth/logout': {  },
  '/auth/login': {  },
  '/feed.xml': {  },
  '/': {  },
  '/relajacion-progresiva-de-jacobson': {  },
  '/progressive-muscle-relaxation': {  },
  '/what-is-ericksonian-hypnosis': {  },
  '/ai-hypnosis-how-it-works': {  },
  '/hypnosis-for-confidence': {  },
  '/hypnosis-vs-meditation': {  },
  '/meditation-for-anxiety': {  },
  '/hypnosis-for-anxiety': {  },
  '/hypnosis-for-stress': {  },
  '/autogenes-training': {  },
  '/hypnosis-for-focus': {  },
  '/hypnosis-for-sleep': {  },
  '/jiritsu-kunren-ho': {  },
  '/meditacion-guiada': {  },
  '/training-autogeno': {  },
  '/trening-autogenny': {  },
  '/sleep-meditation': {  },
  '/:lang?': { lang: string | number | undefined },
  '/zi-wo-cui-mian': {  },
  '/sophrologie': {  },
  '/meditation': {  },
  '/yoga-nidra': {  },
  '/session': {  },
  '/legal': {  },
  '/nsdr': {  },
  '/webhook': {  },
  '/health': {  }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function buildPath<TRouterPath extends RouterPath>(route: TRouterPath, params: InputParams[TRouterPath]) {
  return route
    .replace(/'/g, '')
    .split('/')
    .map((part) =>
      part.startsWith(':') ? params[part.replace(':', '').replace('?', '') as keyof InputParams[TRouterPath]] : part,
    )
    .filter((part) => part !== undefined)
    .join('/')
}

function unsafeBuildPath<TRouterPath extends RouterPath>(
  route: TRouterPath,
  params: Record<string, unknown>,
) {
  return route
    .replace(/'/g, '')
    .split('/')
    .map((part) => (part.startsWith(':') ? params[part.replace(':', '').replace('?', '')] : part))
    .filter((part) => part !== undefined)
    .join('/')
}
